import type { GridColumn } from '../../components/tables/EditableGrid';

/**
 * Project-level Tests tab grid (BUG-2026-0143 follow-up): read-only columns for
 * the shared EditableGrid, replacing the tab's original hand-rolled MUI table.
 * Display-only derived fields (SampleDisplay/TestDateDisplay) are precomputed
 * in TestsTabContent so sorting and the Excel-style column filters operate on
 * exactly what the user sees.
 */
export const projectTestsGridColumns: GridColumn[] = [
  { field: 'WorkOrderId', headerName: 'Work Order', type: 'text', width: 130, readonly: true },
  { field: 'LocationId', headerName: 'Location', type: 'text', width: 140, readonly: true },
  { field: 'SampleDisplay', headerName: 'Sample', type: 'text', width: 160, readonly: true },
  { field: 'TestName', headerName: 'Test', type: 'text', flex: 1, readonly: true },
  { field: 'TestStatus', headerName: 'Status', type: 'text', width: 140, readonly: true },
  { field: 'CheckedBy', headerName: 'Tested By', type: 'text', width: 140, readonly: true },
  { field: 'TestDateDisplay', headerName: 'Test Date', type: 'text', width: 110, readonly: true },
];
